import React from 'react'
import { Link } from 'react-router-dom'
import { IoHeartCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, minusQty, plusQty } from '../Slices/cart/Cart';
import { addToWish, removeFromWish } from '../Slices/cart/Wish';
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa';

function ProductCard({ data, listGrid }) {
  const listGrids = listGrid;
  const cart = useSelector(state => state.cart);
  const wish = useSelector(state => state.wish);
  const dispatch = useDispatch();
  const weburl = useSelector(state => state.constants.weburl);

  const handleAddToCart = (e, item) => {
    e.preventDefault(); // Prevent any default behavior
    e.stopPropagation(); // Stop event bubbling
    dispatch(addToCart(item));
  };

  const handleMinusQty = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(minusQty(id));
  };

  const handlePlusQty = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(plusQty(id));
  };

  const handleWishToggle = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    if (wish.some(wishItem => wishItem.id === item.id)) {
      dispatch(removeFromWish(item));
    } else {
      dispatch(addToWish(item));
    }
  };

  return (
    <div className="w-full pt-4 pb-8 overflow-auto">
      <div className="w-12/12 mx-2" data-aos="fade-up">
        <div className="p-2 mb-4">
          <h1 className="text-2xl font-serif font-bold p-2">
            Latest products on sale
          </h1>
        </div>

        <div className='px-0'>
          <div className={`rounded-sm grid md:grid-cols-4 xl:grid-cols-${listGrids} lg:grid-cols-${listGrids} sm:grid-cols-2 grid-cols-2 gap-2`}>
            {data.map((item, index) => (
              <div key={index} className='relative cursor-pointer group gap-4 shadow-md shadow-gray-100 p-1 text-black bg-[#fff] flex flex-col h-full'>
                {item.unitretailprice !== '0' && (
                  <div className='flex justify-between items-center'>
                    <div className='absolute z-50 top-0 opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out'>
                      <button
                        type="button"
                        onClick={(e) => handleWishToggle(e, item)}
                        className="focus:outline-none"
                      >
                        {wish.some(wishItem => wishItem.id === item.id) ? (
                          <IoHeartCircleOutline size={35} className='text-red-800' />
                        ) : (
                          <IoHeartCircleOutline className='text-gray-700' size={35} />
                        )}
                      </button>
                    </div>
                    <div className='bg-red-600 text-white text-sm font-serif p-1 rounded-sm absolute z-50 top-0 right-0 opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out'>
                      {item.qty > 1 ? 'In Stock' : 'Not Available'}
                    </div>
                  </div>
                )}

                {/* Image Container with Aspect Ratio */}
                <div className='relative transition-all duration-700 ease-in-out hover:scale-105'>
                  <div className='aspect-square overflow-hidden rounded-sm'>
                    <Link to={`/singleproduct/${item.id}`}>
                      <img 
                        alt='newitem' 
                        className='w-full h-full object-contain' 
                        src={item.image ? `${weburl}/${item.image}` : `images/placeholder.png`}
                      />
                    </Link>
                  </div>
                  
                  {/* Badge Container */}
                  <div className='absolute inset-x-0 bottom-0 z-10'>
                    <div className='flex justify-between items-end gap-1'>
                      {item.shipping === '1' && (
                        <div className='animate-pulse flex-1'>
                          <div className='bg-yellow-400 text-black px-1.5 py-1 sm:px-2 sm:py-1.5 rounded-md text-[9px] sm:text-xs font-bold shadow-md text-center'>
                            <span className='inline-block mr-0.5 sm:mr-1 text-[10px] sm:text-sm'>🚚</span>
                            <span className='hidden xs:inline'>Free Shipping</span>
                            <span className='xs:hidden'>Free</span>
                          </div>
                        </div>
                      )}
                      
                      {item.unitretailprice > item.unitsaleprice && (
                        <div className={`animate-pulse ${item.shipping === '1' ? 'flex-1' : 'ml-auto'}`}>
                          <div className='bg-red-600 text-white px-1.5 py-1 sm:px-2 sm:py-1.5 rounded-md text-[9px] sm:text-xs font-bold shadow-md text-center whitespace-nowrap'>
                            {Math.round(((item.unitretailprice - item.unitsaleprice) / item.unitretailprice) * 100)}% OFF
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Product Details */}
                <div className='p-2 border-t-2 border-gray-50 mt-auto'>
                  <div className='flex flex-col justify-between mt-2'>
                    <div className='flex justify-between'>
                      <p className='text-gray-400 text-sm'>{item.category_name}</p>
                      <div>
                        <Link to={`/singleproduct/${item.id}`}>
                          <p className='font-semibold text-sm'>Rs:{item.unitsaleprice}</p>
                        </Link>
                      </div>
                    </div>
                    
                    <h1 className='font-serif text-sm'>
                      <Link to={`/singleproduct/${item.id}`}>{item.name.slice(0, 20)}...</Link>
                    </h1>

                    <div className='flex flex-row mt-3 justify-start'>
                      {item.unitretailprice !== '0' ? (
                        cart.some(cartitem => cartitem.id === item.id) ? (
                          <div className='flex transition-all duration-700 ease-in-out justify-around items-center w-24 bg-gray-50 border h-8 rounded-full'>
                            <button
                              type="button"
                              onClick={(e) => handleMinusQty(e, item.id)}
                              className="focus:outline-none"
                            >
                              <FaMinusCircle className='font-extrabold text-green-600 text-[30px] hover:text-green-500' />
                            </button>
                            <span className='font-bold text-[25px]'>
                              {cart.find(cartitem => cartitem.id === item.id).qty}
                            </span>
                            <button
                              type="button"
                              onClick={(e) => handlePlusQty(e, item.id)}
                              className="focus:outline-none"
                            >
                              <FaPlusCircle className='font-extrabold text-red-600 text-[30px] hover:text-red-500' />
                            </button>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={(e) => handleAddToCart(e, item)}
                            className='transition-all flex justify-center p-1 items-center duration-700 ease-in-out hover:scale-105 relative h-8 w-24 border border-gray-950 rounded-full bg-white focus:outline-none'
                          >
                            <p className='font-bold text-gray-700'>+Add</p>
                          </button>
                        )
                      ) : (
                        <Link to={'/quote'} className='transition-all'>
                          <div className='transition-all flex justify-center p-1 items-center duration-700 ease-in-out hover:scale-105 relative w-24 border border-gray-950 rounded-full'>
                            <p className='font-bold text-gray-700'>Options</p>
                          </div>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;